// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "896cd220",
    "hash": "896cd220",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "896cd220",
    "semverString": null,
    "version": "2026.5.0.4"
};
/* tslint:enable */
